/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const { ALL_LANGUAGES_AVAILABLE } = require("./src/constants")

// You can delete this file if you're not using it
require("./src/index.css")

const HOME_PATH = "/"

// We can do this only for home page. This is because the rest of URLs
// came internationalized from locize right now
exports.onClientEntry = () => {
  const userLang = navigator.language.substr(0, 2)
  const currentPath = window.location.pathname
  if (
    "en" !== userLang &&
    ALL_LANGUAGES_AVAILABLE.includes(userLang) &&
    currentPath === HOME_PATH
  ) {
    window.location.pathname = `/${userLang}${currentPath}`
  }
}
